

angular
.module('inkfinder')
.factory('FormatShopHoursDescription', function FormatShopHoursDescription(
  _
) {
  // Public methods
  FormatShopHoursDescription.format = format;
  /**
   * @name format
   * @description Function to format the description of shop hours in a human
   * readable format.
   * @param {array} hours The hours to format.
   * @return {string} Returns the description of shop hours.
   */
  function format(hours) {
    let formattedHoursDescription;
    if (hours[0].display.selectedDays.length === 7) {
      formattedHoursDescription = 'Open daily from ';
    } else {
      let dayNames = _.map(hours[0].display.selectedDays, function(day) {
        return day.name + ', ';
      });
      formattedHoursDescription = 'Open ' + dayNames.toString() + ' from ';
    }
    formattedHoursDescription += hours[0].display.startTime + ' to ' +
    hours[0].display.endTime;
    return formattedHoursDescription;
  }
  return FormatShopHoursDescription;
});



// WEBPACK FOOTER //
// ./components/shop/hours/util/format-shop-hours-description.service.js